import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getEQTypeList(params) {
  return request({
    url: URL.mdm.basicData.eqType,
    method: 'get',
    params
  })
}

export function getEQTypesByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformEQType,
    method: 'get',
    params
  })
}

export function getAllEQTypeTemplate(params) {
  return request({
    url: URL.mdm.basicData.eqTypeTemplate,
    method: 'get',
    params
  })
}

export function saveEQType(data) {
  return request({
    url: URL.mdm.basicData.eqType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addEQTypeByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformEQType,
    method: 'post',
    data
  })
}

export function saveEQTypes(data) {
  return request({
    url: URL.mdm.basicData.eqTypes,
    method: 'post',
    data
  })
}

export function delEQType(uuid) {
  return request({
    url: URL.mdm.basicData.eqType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
